// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import { openMPView } from '../../modules/monopoly/actions/routes';
import { selectIsMPEnabled } from '../../modules/monopoly/selectors/computed/runtime';
import { selectShowOperationBanners } from '../../selectors/operations.selector';

import MenuDesktopMPButton from './MenuDesktopMPButton';
import selectMPButtonProps from './MenuDesktopMPButton.selector';

const MenuDesktopMPButtonContainer = () => {
  const isMPEnabled = useSelector(selectIsMPEnabled);
  const showOperationBanners = useSelector(selectShowOperationBanners);
  const selectedProps = useSelector(selectMPButtonProps);

  const memoizedActions = useMemo(
    () => ({
      openMPView,
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(memoizedActions);

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return isMPEnabled && showOperationBanners ? <MenuDesktopMPButton {...enhancedProps} /> : null;
};

export default MenuDesktopMPButtonContainer;
